module.exports = __webpack_public_path__ + "img/Cooperation.0bae074d.svg";